import * as React from 'react'

import { Box, Icon, type LargeIcon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import GetMyCardsNowButton from 'modules/expenses/components/common/CardsLandingPage/Content/GetMyCardsNowButton'

import * as styles from './index.vanilla.css'

interface Feature {
  iconName: LargeIcon
  title: string
  description: string
}

const getFeaturesData: () => Feature[][] = () => [
  [
    {
      iconName: 'credit-card',
      title: i18n.t(
        'expenses_v2.cards.blocks.features.points.virtual_single_use_and_physical.title'
      ),
      description: i18n.t(
        'expenses_v2.cards.blocks.features.points.virtual_single_use_and_physical.description'
      ),
    },
    {
      iconName: 'control-navigation-adjust-sound',
      title: i18n.t('expenses_v2.cards.blocks.features.points.card_limits.title'),
      description: i18n.t('expenses_v2.cards.blocks.features.points.card_limits.description'),
    },
    {
      iconName: 'wallet',
      title: i18n.t('expenses_v2.cards.blocks.features.points.digital_wallets.title'),
      description: i18n.t('expenses_v2.cards.blocks.features.points.digital_wallets.description'),
    },
  ],
  [
    {
      iconName: 'document-folder-disorder-list',
      title: i18n.t('expenses_v2.cards.blocks.features.points.approval_policies_rules.title'),
      description: i18n.t(
        'expenses_v2.cards.blocks.features.points.approval_policies_rules.description'
      ),
    },
    {
      iconName: 'task-list-search',
      title: i18n.t('expenses_v2.cards.blocks.features.points.smart_invoice_reading.title'),
      description: i18n.t(
        'expenses_v2.cards.blocks.features.points.smart_invoice_reading.description'
      ),
    },
    {
      iconName: 'input-field',
      title: i18n.t('expenses_v2.cards.blocks.features.points.custom_fields.title'),
      description: i18n.t('expenses_v2.cards.blocks.features.points.custom_fields.description'),
    },
  ],
  [
    {
      iconName: 'money-bag',
      title: i18n.t('expenses_v2.cards.blocks.features.points.out_of_pocket_reimbursement.title'),
      description: i18n.t(
        'expenses_v2.cards.blocks.features.points.out_of_pocket_reimbursement.description'
      ),
    },
    {
      iconName: 'check',
      title: i18n.t('expenses_v2.cards.blocks.features.points.tax_office_certification.title'),
      description: i18n.t(
        'expenses_v2.cards.blocks.features.points.tax_office_certification.description'
      ),
    },
    {
      iconName: 'download',
      title: i18n.t('expenses_v2.cards.blocks.features.points.expenses_reports.title'),
      description: i18n.t('expenses_v2.cards.blocks.features.points.expenses_reports.description'),
    },
  ],
]

const Feature: React.FC<Feature> = ({ iconName, title, description }) => (
  <Box
    className={styles.featuresColumn}
    flexDirection="column"
    maxWidth="s400"
    gap="s16"
    alignItems="center"
    justifyContent="center"
    textAlign="center"
  >
    <Box
      padding="s16"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'radicalRed200',
        },
      }}
      borderRadius={{
        all: 'rel500',
      }}
    >
      <Icon.Large icon={iconName} color="radicalRed1000" />
    </Box>
    <Box flexDirection="column" gap="s4">
      <Text htmlTag="h3" color="grey1000" weight="medium" size="300">
        {title}
      </Text>
      <Text.Normal color="grey800">{description}</Text.Normal>
    </Box>
  </Box>
)

interface FeaturesSectionProps {
  onGetCardsClick: () => void
}

const FeaturesSection: React.FC<FeaturesSectionProps> = ({ onGetCardsClick }) => (
  <Box
    className="features"
    paddingX="s64"
    paddingY="s32"
    width="full"
    flexDirection="column"
    gap="s64"
  >
    <Box className="features__section-header" flexDirection="row" justifyContent="spaceAround">
      <Box flexDirection="column" gap="s8" maxWidth="s400" textAlign="center">
        <Text.Header2 htmlTag="h2">
          {i18n.t('expenses_v2.cards.blocks.features.title')}
        </Text.Header2>
        <Text.Normal>{i18n.t('expenses_v2.cards.blocks.features.subtitle')}</Text.Normal>
      </Box>
    </Box>
    <Box flexDirection="column" gap="s40">
      {getFeaturesData().map((row, i) => (
        <Box flexDirection="row" justifyContent="spaceAround" gap="s48" key={i}>
          {row.map(({ iconName, title, description }) => (
            <Feature key={title} iconName={iconName} title={title} description={description} />
          ))}
        </Box>
      ))}
    </Box>
    <Box flexDirection="column" alignItems="center" gap="s8">
      <GetMyCardsNowButton onClick={onGetCardsClick} />
    </Box>
  </Box>
)

export default FeaturesSection
